import { FC } from "react";
import { Button, makeStyles } from "@material-ui/core";

import { getCookie, getQueryParams, mountQueryString } from "lib/helpers";
import * as routes from "routes";
import { SocialProviders } from "routes/types";
import theme, { Theme } from "theme";

const socialColorsMap = {
  facebook: "#3B5998",
  google: "#DC462E",
  linkedin_oauth2: "#0077B5",
};
const useStyles = makeStyles<Theme, { provider: SocialProviders }>(() => ({
  socialButton: {
    backgroundColor: props => socialColorsMap[props.provider],
    color: theme.palette.primary.contrastText,
    borderRadius: "0.125rem",
    marginBottom: theme.spacing(2),
    padding: "0px",
    textTransform: "none",
    fontSize: "16px",
    minHeight: "40px",
    "&:hover": {
      backgroundColor: props => socialColorsMap[props.provider],
    },
  },
}));

interface SocialButtonProps {
  provider: SocialProviders;
}

const SocialButton: FC<SocialButtonProps> = ({ provider }) => {
  const classes = useStyles({ provider });
  const next = getQueryParams().next;
  const socialLoginNext = next
    ? routes.sellerCompleteAccount() +
      mountQueryString({
        next: next,
      })
    : routes.sellerCompleteAccount();
  const socialURL =
    routes.directorySocialLogin(provider) +
    mountQueryString({
      process: "login",
      next: socialLoginNext,
    });

  const getDisplayName = (provider: SocialProviders) =>
    ({
      facebook: "Facebook",
      google: "Google",
      linkedin_oauth2: "LinkedIn",
    }[provider]);

  const getIcon = (provider: SocialProviders) =>
    ({
      facebook: "fa fa-facebook-square",
      google: "fa fa-google-plus",
      linkedin_oauth2: "fa fa-linkedin",
    }[provider]);

  const csrfToken = getCookie("csrftoken");
  return (
    <form action={socialURL} method="post">
      <input type="hidden" name="csrfmiddlewaretoken" value={csrfToken} />
      <Button
        id={`button-${provider}`}
        className={classes.socialButton}
        variant="contained"
        fullWidth
        disableRipple
        disableFocusRipple
        disableTouchRipple
        type="submit"
      >
        <i
          className={getIcon(provider)}
          style={{
            display: "flex",
            marginRight: "10px",
            marginBottom: provider !== "google" ? "2px" : "",
          }}
        />
        Sign in with {getDisplayName(provider)}
      </Button>
    </form>
  );
};

export default SocialButton;
